import { useEffect, useState } from "react";
import CauHinhApi from "service/cauHinhApi";
import CamDoApi from "service/camDoApi";
import cauHinh from "utils/cauHinh";

// Cờ isHinhThucThanhToan cho form cầm đồ, tách riêng với IsQuanLyMuaBan (màn mua bán không dùng hook này).
export const docCauHinhHinhThucThanhToan = () =>
  CauHinhApi.getConfigSys1().then((response) => {
    if (response.status !== 200 || !Array.isArray(response.data)) return false;
    const config = response.data.find(
      (e) =>
        (e.keyConfig || "").toUpperCase() ===
        cauHinh.sKey.IsHinhThucThanhToan.toUpperCase()
    );
    return config != null && config.valueConfig === "1";
  });

// Hình thức của phiếu giải ngân hợp đồng ("0" | "1"), chưa có thì Tiền mặt
export const layHinhThucThanhToanHopDong = (choVayId) =>
  CamDoApi.hinhThucThanhToanHopDong(choVayId).then((response) =>
    response.status === 200 && response.data
      ? String(response.data.HinhThucThanhToan || 0)
      : "0"
  );

function useHinhThucThanhToan() {
  const [batHinhThucThanhToan, setBatHinhThucThanhToan] = useState(false);

  useEffect(() => {
    let daHuy = false;
    docCauHinhHinhThucThanhToan().then((bat) => {
      if (!daHuy) setBatHinhThucThanhToan(bat);
    });
    return () => {
      daHuy = true;
    };
  }, []);

  return batHinhThucThanhToan;
}

export default useHinhThucThanhToan;
